import React from 'react';
import { Button } from '../components/ui/button';
import { Instagram, Facebook, Youtube, MessageCircle } from 'lucide-react';

const LandingPage = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/628113690770', '_blank');
  };

  return (
    <div className="landing-container">
      {/* Background Image with Overlay */}
      <div className="background-overlay" />
      
      {/* Main Content */}
      <div className="content-wrapper">
        {/* Logo Section */}
        <div className="logo-section">
          <img
            src="https://lh3.googleusercontent.com/d/12n8tHFbCoXWF-I-6jXe3n7OOsJiEcF5Y"
            alt="Drumminded Logo"
            className="logo-image"
          />
        </div>

        {/* Headline and Description */}
        <div className="text-content">
          <h1 className="headline">Official Contact Information</h1>
          <p className="description">
            For product inquiries, orders, reseller opportunities, and customer support,
            please contact us through our official WhatsApp account.
          </p>
        </div>

        {/* WhatsApp CTA Button */}
        <div className="cta-section">
          <Button
            onClick={handleWhatsAppClick}
            className="whatsapp-button"
            size="lg"
          >
            <MessageCircle className="button-icon" />
            Chat on WhatsApp
          </Button>
          <p className="contact-label">Official Drumminded Contact</p>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p className="copyright">© Drumminded</p>
          <div className="social-icons">
            <a
              href="https://www.instagram.com/drumminded"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Instagram"
            >
              <Instagram className="social-icon" />
            </a>
            <a
              href="https://www.facebook.com/drumminded"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Facebook"
            >
              <Facebook className="social-icon" />
            </a>
            <a
              href="https://www.youtube.com/@drumminded"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="YouTube"
            >
              <Youtube className="social-icon" />
            </a>
          </div>
          <div className="store-address">
            <p className="store-name">Drumminded Drum Store</p>
            <p className="address-line">Putro Agung Wetan no. 26</p>
            <p className="address-line">Tambaksari, Surabaya - 60133</p>
            <p className="address-line">East Java, Indonesia</p>
            <p className="address-line">Ph/WA : +62 811 369 0770</p>
          </div>
          <p className="website">www.drumminded.com</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;